document.querySelectorAll('.alu-grid .card-collection').forEach((card) =>
    card.addEventListener("click", function(event) {
        if (window.innerWidth < 768) {

            let header = this.querySelector('h3')
            if (header.style.color == '') {
                header.style.color = '#b28b33'
            } else {
                header.style.color = ''
            }

            let hoverbox = this.querySelector('.hover-text-wrapper')

            if (hoverbox.style.opacity == '0.85') {
                hoverbox.style.opacity = '0'
            } else {
                hoverbox.style.opacity = '0.85'
            }
        }
    })
);
